var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-pie-radius"}},[_c('v-chart',{ref:"my",attrs:{"options":_vm.option,"initOptions":_vm.initOptions,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }